var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.9 8.4 7l4.9-4.9c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3L7 5.6 2.1.7C1.9.5 1.7.4 1.4.4 1.1.4.9.5.7.7c-.4.4-.4 1 0 1.4L5.6 7 .7 11.9c-.4.4-.4 1 0 1.4s1 .4 1.4 0L7 8.4l4.9 4.9c.4.4 1 .4 1.4 0s.4-1 0-1.4z"
  })));
};
export default SvgX;